import ShareTheLovePage from 'modules/ShareTheLove/page';

module.exports = {
  component: ShareTheLovePage,
  path: '/share-the-love',
};
